if (!customElements.get('collapsible-text')) {
  class CollapsibleText extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.collapsible-text__content');
      this.toggle = this.querySelector('.collapsible-text__toggle');
      this.collapsedHeight = parseInt(this.dataset.collapsedHeight, 10) || 150;

      if (this.content.scrollHeight > this.collapsedHeight + 50) {
        this.classList.add('is-collapsible', 'is-collapsed');
        this.toggle.addEventListener('click', this.handleToggle.bind(this));
      }
    }

    handleToggle() {
      if (this.classList.contains('is-collapsed')) {
        this.expand();
      } else {
        this.collapse();
      }
    }

    expand() {
      this.style.setProperty('--expanded-height', `${this.content.scrollHeight}px`);
      this.classList.remove('is-collapsed');
      this.toggle.setAttribute('aria-expanded', 'true');

      this.content.addEventListener(
        'transitionend',
        () => this.classList.add('is-expanded'),
        { once: true }
      );
    }

    collapse() {
      this.classList.remove('is-expanded');
      this.style.setProperty('--expanded-height', `${this.content.scrollHeight}px`);

      void this.content.offsetHeight;

      this.classList.add('is-collapsed');
      this.toggle.setAttribute('aria-expanded', 'false');

      if (!this.getBoundingClientRect().top < 0) return;
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  customElements.define('collapsible-text', CollapsibleText);
}
